import events from "./events.js";

const artikelPrefix = "ArtikelKlick";

export function setProductAttribution(model, message) {
	const items = message?.ecommerce?.items;
	if (!items || !Array.isArray(items)) return;

	const productPayload = getProductData(model, message);
	for (const item of items) {
		const productId = item.item_id;
		if (!productId) continue;

		productPayload["id"] = productId;
		setProductAttributionData(productId, JSON.stringify(productPayload));
	}
}

export function isProductAttributionRequired(eventName) {
	return events.includes(eventName);
}

export function setProductAttributionData(id, data) {
	try {
		localStorage.setItem(`${artikelPrefix}-${id}`, data);
	} catch (e) { }
}

export function getProductAttributionData(id) {
	try {
		return JSON.parse(localStorage.getItem(`${artikelPrefix}-${id}`)) || {};
	} catch (e) {
		return {};
	}
}

export function clearProductAttribution() {
	try {
		const keysToRemove = [];
		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);
			if (key && key.startsWith(`${artikelPrefix}-`)) {
				keysToRemove.push(key);
			}
		}
		for (const key of keysToRemove) {
			localStorage.removeItem(key);
		}
	} catch (e) { }
}

export function getProductData(model, message) {
	const ecommerce = message?.ecommerce || {};
	const firstProduct = ecommerce.items?.[0] || {};

	// Fallback auf Item-Level: Für add_to_cart steht item_list_id/item_list_name nicht
	// mehr auf Event-Ebene (würde sonst durch den Kontext des Klicks, z.B. "hinzugefuegt-overlay",
	// die echte Listen-Herkunft überschreiben). Die korrekte Herkunft wird stattdessen aus
	// dem Item übernommen — dort steht sie via productAttribution oder dl-product Attribute.
	const component = ecommerce.item_list_id || firstProduct.item_list_id || "";
	const list = ecommerce.item_list_name || firstProduct.item_list_name || "";
	const { produktart } = firstProduct;

	return {
		id: "",
		seitenart: model.seitentyp || "",
		produktseite: model.seite || "",
		produktsuchbegriff: model.suchbegriff || "",
		produktab_test: model.ab_test || "",
		produktkomponente: component,
		produktliste: list,
		produktart: produktart || ""
	}
}
